// Metadata for top 100 AWS Terraform resources
export const awsTop100Meta: Record<
  string,
  { displayName: string; category: string }
> = {
  // Compute
  aws_instance: {
    displayName: "EC2 Instance",
    category: "compute",
  },
  aws_autoscaling_group: {
    displayName: "Auto Scaling Group",
    category: "compute",
  },
  aws_launch_template: {
    displayName: "Launch Template",
    category: "compute",
  },
  aws_lambda_function: {
    displayName: "Lambda Function",
    category: "compute",
  },
  aws_ecs_cluster: {
    displayName: "ECS Cluster",
    category: "compute",
  },
  aws_ecs_service: {
    displayName: "ECS Service",
    category: "compute",
  },
  aws_ecs_task_definition: {
    displayName: "ECS Task Definition",
    category: "compute",
  },
  aws_eks_cluster: {
    displayName: "EKS Cluster",
    category: "compute",
  },
  aws_eks_node_group: {
    displayName: "EKS Node Group",
    category: "compute",
  },
  aws_elastic_beanstalk_application: {
    displayName: "Elastic Beanstalk Application",
    category: "compute",
  },
  aws_elastic_beanstalk_environment: {
    displayName: "Elastic Beanstalk Environment",
    category: "compute",
  },
  aws_batch_compute_environment: {
    displayName: "Batch Compute Environment",
    category: "compute",
  },
  aws_batch_job_definition: {
    displayName: "Batch Job Definition",
    category: "compute",
  },
  aws_batch_job_queue: {
    displayName: "Batch Job Queue",
    category: "compute",
  },

  // Storage
  aws_s3_bucket: {
    displayName: "S3 Bucket",
    category: "storage",
  },
  aws_s3_bucket_policy: {
    displayName: "S3 Bucket Policy",
    category: "storage",
  },
  aws_s3_bucket_public_access_block: {
    displayName: "S3 Bucket Public Access Block",
    category: "storage",
  },
  aws_s3_object: {
    displayName: "S3 Object",
    category: "storage",
  },
  aws_ebs_volume: {
    displayName: "EBS Volume",
    category: "storage",
  },
  aws_ebs_snapshot: {
    displayName: "EBS Snapshot",
    category: "storage",
  },
  aws_efs_file_system: {
    displayName: "EFS File System",
    category: "storage",
  },
  aws_efs_mount_target: {
    displayName: "EFS Mount Target",
    category: "storage",
  },
  aws_fsx_windows_file_system: {
    displayName: "FSx for Windows File Server",
    category: "storage",
  },
  aws_fsx_lustre_file_system: {
    displayName: "FSx for Lustre",
    category: "storage",
  },
  aws_glacier_vault: {
    displayName: "Glacier Vault",
    category: "storage",
  },

  // Database
  aws_db_instance: {
    displayName: "RDS Instance",
    category: "database",
  },
  aws_db_subnet_group: {
    displayName: "DB Subnet Group",
    category: "database",
  },
  aws_db_parameter_group: {
    displayName: "DB Parameter Group",
    category: "database",
  },
  aws_rds_cluster: {
    displayName: "RDS Cluster (Aurora)",
    category: "database",
  },
  aws_rds_cluster_instance: {
    displayName: "RDS Cluster Instance",
    category: "database",
  },
  aws_dynamodb_table: {
    displayName: "DynamoDB Table",
    category: "database",
  },
  aws_elasticache_cluster: {
    displayName: "ElastiCache Cluster",
    category: "database",
  },
  aws_elasticache_replication_group: {
    displayName: "ElastiCache Replication Group",
    category: "database",
  },
  aws_redshift_cluster: {
    displayName: "Redshift Cluster",
    category: "database",
  },
  aws_neptune_cluster: {
    displayName: "Neptune Cluster",
    category: "database",
  },
  aws_docdb_cluster: {
    displayName: "DocumentDB Cluster",
    category: "database",
  },
  aws_docdb_cluster_instance: {
    displayName: "DocumentDB Instance",
    category: "database",
  },

  // Networking
  aws_vpc: {
    displayName: "VPC",
    category: "networking",
  },
  aws_subnet: {
    displayName: "Subnet",
    category: "networking",
  },
  aws_internet_gateway: {
    displayName: "Internet Gateway",
    category: "networking",
  },
  aws_nat_gateway: {
    displayName: "NAT Gateway",
    category: "networking",
  },
  aws_route_table: {
    displayName: "Route Table",
    category: "networking",
  },
  aws_route_table_association: {
    displayName: "Route Table Association",
    category: "networking",
  },
  aws_security_group: {
    displayName: "Security Group",
    category: "networking",
  },
  aws_security_group_rule: {
    displayName: "Security Group Rule",
    category: "networking",
  },
  aws_network_acl: {
    displayName: "Network ACL",
    category: "networking",
  },
  aws_network_interface: {
    displayName: "Network Interface",
    category: "networking",
  },
  aws_eip: {
    displayName: "Elastic IP",
    category: "networking",
  },
  aws_vpc_peering_connection: {
    displayName: "VPC Peering Connection",
    category: "networking",
  },
  aws_vpn_gateway: {
    displayName: "VPN Gateway",
    category: "networking",
  },
  aws_vpn_connection: {
    displayName: "VPN Connection",
    category: "networking",
  },
  aws_customer_gateway: {
    displayName: "Customer Gateway",
    category: "networking",
  },
  aws_route53_zone: {
    displayName: "Route 53 Hosted Zone",
    category: "networking",
  },
  aws_route53_record: {
    displayName: "Route 53 Record",
    category: "networking",
  },
  aws_cloudfront_distribution: {
    displayName: "CloudFront Distribution",
    category: "networking",
  },
  aws_elb: {
    displayName: "Classic Load Balancer",
    category: "networking",
  },
  aws_lb: {
    displayName: "Application/Network Load Balancer",
    category: "networking",
  },
  aws_lb_target_group: {
    displayName: "Load Balancer Target Group",
    category: "networking",
  },
  aws_lb_listener: {
    displayName: "Load Balancer Listener",
    category: "networking",
  },
  aws_api_gateway_rest_api: {
    displayName: "API Gateway REST API",
    category: "networking",
  },
  aws_api_gateway_resource: {
    displayName: "API Gateway Resource",
    category: "networking",
  },
  aws_api_gateway_method: {
    displayName: "API Gateway Method",
    category: "networking",
  },
  aws_api_gateway_deployment: {
    displayName: "API Gateway Deployment",
    category: "networking",
  },
  aws_apigatewayv2_api: {
    displayName: "API Gateway v2 API",
    category: "networking",
  },
  aws_apigatewayv2_stage: {
    displayName: "API Gateway v2 Stage",
    category: "networking",
  },
  aws_direct_connect_gateway: {
    displayName: "Direct Connect Gateway",
    category: "networking",
  },
  aws_vpc_endpoint: {
    displayName: "VPC Endpoint",
    category: "networking",
  },

  // Security
  aws_iam_role: {
    displayName: "IAM Role",
    category: "security",
  },
  aws_iam_role_policy: {
    displayName: "IAM Role Policy",
    category: "security",
  },
  aws_iam_policy: {
    displayName: "IAM Policy",
    category: "security",
  },
  aws_iam_policy_attachment: {
    displayName: "IAM Policy Attachment",
    category: "security",
  },
  aws_iam_user: {
    displayName: "IAM User",
    category: "security",
  },
  aws_iam_group: {
    displayName: "IAM Group",
    category: "security",
  },
  aws_iam_access_key: {
    displayName: "IAM Access Key",
    category: "security",
  },
  aws_kms_key: {
    displayName: "KMS Key",
    category: "security",
  },
  aws_kms_alias: {
    displayName: "KMS Alias",
    category: "security",
  },
  aws_secretsmanager_secret: {
    displayName: "Secrets Manager Secret",
    category: "security",
  },
  aws_secretsmanager_secret_version: {
    displayName: "Secrets Manager Secret Version",
    category: "security",
  },
  aws_acm_certificate: {
    displayName: "ACM Certificate",
    category: "security",
  },
  aws_cognito_user_pool: {
    displayName: "Cognito User Pool",
    category: "security",
  },
  aws_cognito_identity_pool: {
    displayName: "Cognito Identity Pool",
    category: "security",
  },
  aws_waf_web_acl: {
    displayName: "WAF Web ACL",
    category: "security",
  },
  aws_wafv2_web_acl: {
    displayName: "WAF v2 Web ACL",
    category: "security",
  },
  aws_guardduty_detector: {
    displayName: "GuardDuty Detector",
    category: "security",
  },
  aws_security_hub_account: {
    displayName: "Security Hub Account",
    category: "security",
  },

  // Analytics
  aws_kinesis_stream: {
    displayName: "Kinesis Stream",
    category: "analytics",
  },
  aws_kinesis_firehose_delivery_stream: {
    displayName: "Kinesis Firehose",
    category: "analytics",
  },
  aws_glue_catalog_database: {
    displayName: "Glue Catalog Database",
    category: "analytics",
  },
  aws_glue_crawler: {
    displayName: "Glue Crawler",
    category: "analytics",
  },
  aws_athena_database: {
    displayName: "Athena Database",
    category: "analytics",
  },
  aws_athena_workgroup: {
    displayName: "Athena Workgroup",
    category: "analytics",
  },
  aws_emr_cluster: {
    displayName: "EMR Cluster",
    category: "analytics",
  },

  // DevOps
  aws_codepipeline: {
    displayName: "CodePipeline",
    category: "devops",
  },
  aws_codebuild_project: {
    displayName: "CodeBuild Project",
    category: "devops",
  },
  aws_codecommit_repository: {
    displayName: "CodeCommit Repository",
    category: "devops",
  },
  aws_codedeploy_app: {
    displayName: "CodeDeploy Application",
    category: "devops",
  },
  aws_codedeploy_deployment_group: {
    displayName: "CodeDeploy Deployment Group",
    category: "devops",
  },
  aws_ecr_repository: {
    displayName: "ECR Repository",
    category: "devops",
  },

  // Monitoring
  aws_cloudwatch_log_group: {
    displayName: "CloudWatch Log Group",
    category: "monitoring",
  },
  aws_cloudwatch_log_stream: {
    displayName: "CloudWatch Log Stream",
    category: "monitoring",
  },
  aws_cloudwatch_metric_alarm: {
    displayName: "CloudWatch Metric Alarm",
    category: "monitoring",
  },
  aws_cloudwatch_dashboard: {
    displayName: "CloudWatch Dashboard",
    category: "monitoring",
  },
  aws_sns_topic: {
    displayName: "SNS Topic",
    category: "monitoring",
  },
  aws_sns_topic_subscription: {
    displayName: "SNS Topic Subscription",
    category: "monitoring",
  },
  aws_sqs_queue: {
    displayName: "SQS Queue",
    category: "monitoring",
  },
  aws_cloudtrail: {
    displayName: "CloudTrail",
    category: "monitoring",
  },

  // AI/ML
  aws_sagemaker_notebook_instance: {
    displayName: "SageMaker Notebook Instance",
    category: "ai",
  },
  aws_sagemaker_model: {
    displayName: "SageMaker Model",
    category: "ai",
  },
  aws_sagemaker_endpoint: {
    displayName: "SageMaker Endpoint",
    category: "ai",
  },
  aws_sagemaker_endpoint_configuration: {
    displayName: "SageMaker Endpoint Configuration",
    category: "ai",
  },

  // Other
  aws_ssm_parameter: {
    displayName: "SSM Parameter",
    category: "other",
  },
  aws_backup_vault: {
    displayName: "Backup Vault",
    category: "other",
  },
  aws_backup_plan: {
    displayName: "Backup Plan",
    category: "other",
  },
  aws_config_configuration_recorder: {
    displayName: "Config Configuration Recorder",
    category: "other",
  },
  aws_cloudformation_stack: {
    displayName: "CloudFormation Stack",
    category: "other",
  },
};

export const top100Meta = awsTop100Meta;
export default awsTop100Meta;
